import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Header from '../../components/template/Header';
import Footer from '../../components/template/Footer';
import BreadCrumb from '../../components/template/BreadCrumb';
import { Link } from 'react-router-dom';
import Spinner from '../../components/layout/Spinner';
import { LittleAngels } from '../../models/littleangel';

function AllLittleAngles() {
  const [littleAngles, setLittleAngles] = useState(LittleAngels);
  return (
    <div>
      <Header active='SUCCESS_STORIES' />
      <BreadCrumb title={'Our Little Angels'} />
      <section className='current ptb-30'>
        <div className='container'>
          <div className='current-project angel-border'>
            <div className='row'>
              <div className='col-md-5'>
                <div className='little-angel-img'>
                  <img src='/assets/images/moksh.jpeg' alt='' />
                </div>
              </div>
              <div className='col-md-7'>
                <div className='little-angel-title'>Moksh Kumar</div>
                <div className='little-angel-age'>5 Years</div>
                {/* <div className="little-angel-documents">
                                    <p className="medical-documents">Medical Documents </p>
                                </div> */}
                <div className='little-angel-description'>
                  <div className='little-angel-heading'>
                    <p>
                      <strong>Forever in Our Hearts – Moksh Kumar</strong>
                    </p>
                  </div>
                  <div className='little-angel-para'>
                    <p>
                      In a heartbreaking turn of events, we received the
                      devastating news that 5-year-old Moksh Kumar, who was
                      bravely fighting Blood Cancer (B-ALL), is no longer with
                      us.
                    </p>

                    <p>
                      Despite his father Rinku Kumar’s tireless efforts and the
                      support extended by the National NGO, Moksh’s courageous
                      battle against this life-threatening illness came to an
                      end.
                    </p>

                    <p>
                      Rinku Kumar, a devoted father from Village Chandpura,
                      District Moradabad, did everything he could to arrange
                      funds for his son’s treatment at AIIMS, New Delhi. The
                      National NGO stood by the family, offering support in
                      their most difficult time.
                    </p>

                    <p>
                      Our deepest condolences go out to the Kumar family. May
                      Moksh’s soul rest in peace, and may his family find
                      strength in the cherished memories they hold.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default AllLittleAngles;
